module.exports = __webpack_public_path__ + "static/media/card2_9.346f9d39.png";